export const MAX_POLL_ATTEMPTS = 50;
export const MAX_POLL_INTERVAL_MS = 25_000;

export function resolvePollDelayMs(attempt: number): number {
  const normalizedAttempt = Math.max(1, Math.floor(attempt));
  const seconds = Math.min(
    MAX_POLL_INTERVAL_MS / 1000,
    Math.abs(normalizedAttempt - 3) + 1
  );
  return seconds * 1000;
}
